import React, { useState, useEffect } from "react";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import { BiMessageSquareDetail } from "react-icons/bi";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#");

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const sections = document.querySelectorAll("section");
        let currentSectionId = "#";

        sections.forEach((section) => {
          const sectionTop = section.offsetTop - 100; // Adjust this value as needed
          const sectionHeight = section.clientHeight;
          if (
            window.pageYOffset >= sectionTop &&
            window.pageYOffset < sectionTop + sectionHeight
          ) {
            currentSectionId = `#${section.id}`;
          }
        });

        setActiveNav(currentSectionId);
      }, 100); // Adjust the debounce delay as needed
    };

    document.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav>
      <a
        href="#"
        onClick={() => setActiveNav("#")}
        className={activeNav === "#" ? "active" : ""}
        alt="Home"
      >
        <AiOutlineHome />
      </a>
      <a
        href="#about"
        onClick={() => setActiveNav("#about")}
        className={activeNav === "#about" ? "active" : ""}
        alt="About"
      >
        <AiOutlineUser />
      </a>
      <a
        href="#skill"
        onClick={() => setActiveNav("#skill")}
        className={activeNav === "#skill" ? "active" : ""}
        alt="Skill"
      >
        <BiBook />
      </a>
      <a
        href="#contact"
        onClick={() => setActiveNav("#contact")}
        className={activeNav === "#contact" ? "active" : ""}
        alt="Contact Me"
      >
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default Nav;
